<template>
  <section id="hero">
        <v-row no-gutters>
          <div class="video-player">
            <video class="video bottomlevel" ref="video" autoplay loop width="1440" >
              <source :src="getHost() + 'subvox_content/hero_movie.mp4'" type="video/mp4">
            </video>
          </div>
              <v-theme-provider dark class="overlay">
                <v-container fill-height>
                  <v-row
                    align="center"
                    class="white--text mx-auto toplevel"
                    justify="center"
                  >
                    <v-col
                      class="white--text text-center toplevel"
                      cols="12"
                      tag="h2"
                    >
                      <span
                        class="font-weight-light"
                        :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                      >
                        WELCOME TO
                      </span>

                      <br>

                      <span
                        :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                        class="font-weight-black"
                      >
                        SUBVOX
                      </span>

                    </v-col>

                    <v-btn
                      class="align-self-end"
                      outlined
                      @click="gotoDemo"
                    >
                      <v-icon>mdi-chevron-double-down</v-icon> Try Demo
                    </v-btn>
                  </v-row>
                </v-container>
              </v-theme-provider>
        </v-row>
  </section>
</template>


<script>
  export default {
    name: 'HeroBlock',

    data: () => ({
    }),
    methods: {
      gotoDemo() {
        this.$vuetify.goTo('#demo');
        this.$emit('openDemo');
      }
    }
  }
</script>


<style scoped>
  

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      -o-object-fit: cover;
         object-fit: cover;
      -o-object-position: center;
         object-position: center;
      z-index: 0;
    }

    .overlay {
      min-height: 990px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }

    .overlay h2 {
        color: tan;
        font-weight: 600;
        margin: 2rem 3rem 0;
        mix-blend-mode: overlay;
        padding: 5px 15px;
        text-align: center;
      z-index: 1;
    }
</style>